var exports = {
  "aw": "xdbfd91f1--abf2fc--slider",
  "M6": "xdbfd91f1--abf2fc--slide",
  "kY": "xdbfd91f1--abf2fc--transition",
};

module.exports = exports;
